export default "__VITE_ASSET__8mwpm3Y7__"